<agr-page-toolbar
  [pageTitle]="(isMobile$ | async) === false ? ('delivery.deliveries' | translate) : ''"
  [isEmpty]="(deliveries$ | async)?.length === 0"
  [emptyTitle]="'delivery-overview.no-deliveries.title' | translate"
  [emptyDescription]="'delivery-overview.no-deliveries.description' | translate"
  [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="add()"
  data-test="delivery-overview"
>
  <ng-container actions>
    <app-delivery-overview-filter></app-delivery-overview-filter>
  </ng-container>

  <agr-table
    [config]="tableConfig"
    [emptyTitle]="'delivery-overview.no-deliveries.title' | translate"
    [emptyDescription]="'delivery-overview.no-deliveries.description' | translate"
    [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
    [isEmpty]="(deliveries$ | async)?.length === 0"
  ></agr-table>

  <ng-template #isActiveColumn let-row="row">
    <mat-slide-toggle
      [hideIcon]="true"
      data-test="delivery-overview__active-toggle"
      color="primary"
      [checked]="row.isActive"
      (change)="setActive($event, row.data, row.externalUniqueIdentifier)"
    >
    </mat-slide-toggle>
  </ng-template>

  <ng-template #showInFinalSetupColumn let-row="row">
    <mat-slide-toggle
      [hideIcon]="true"
      data-test="delivery-overview__toggle-show-in-final-setup"
      color="primary"
      [checked]="row.showInFinalSetup"
      (change)="onToggleShowInFinalSetup($event, row.data, row.externalUniqueIdentifier)"
    >
    </mat-slide-toggle>
  </ng-template>

  <ng-template #actionButtonsColumn let-row="row">
    <button
      mat-icon-button
      *ngIf="row.data.deliveryType === 'Manual'"
      data-test="delivery-overview__edit-button"
      (click)="this.editManualDelivery(row.data.id)"
    >
      <mat-icon>edit</mat-icon>
    </button>
    <button
      mat-icon-button
      *ngIf="row.data.deliveryType === 'Manual'"
      [disabled]="!canRemove(row.data)"
      data-test="delivery-overview__delete-button"
      (click)="this.deleteManualDelivery(row.data.id)"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </ng-template>
</agr-page-toolbar>
